import {
  ADD_NEW_STOCK,
  ADD_NEW_STOCKS,
  UPDATE_STOCK,
  DELETE_STOCK,
  DELETE_STOCKS,
  FETCH_STOCKS,
  FETCH_STOCK,
  START_LOADING,
  END_LOADING,
} from "../actions/constants";
import { idsMatch } from "../utils/ids";

const stocks = (state = { isLoading: true, stocks: [] }, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true };
    case END_LOADING:
      return { ...state, isLoading: false };
    case FETCH_STOCKS:
      return {
        ...state,
        stocks: action.payload,
        currentPage: action.payload.currentPage,
        numberOfPages: action.payload.numberOfPages,
      };
    //   case FETCH_stocks_BY_USER:
    //     return { ...state, stocks: action.payload };

    case FETCH_STOCK:
      return { ...state, stock: action.payload };
    case ADD_NEW_STOCK:
      return { ...state, stocks: [...state.stocks, ...action.payload] };

    case ADD_NEW_STOCKS:
      return { ...state, stocks: [...state.stocks, ...action.payload] };

    case UPDATE_STOCK:
      return {
        ...state,
        stocks: state.stocks.map((stock) =>
          idsMatch(stock.id, action.payload.id) ? action.payload : stock
        ),
      };
    case DELETE_STOCK:
      return {
        ...state,
        stocks: state.stocks.filter((stock) => !idsMatch(stock.id, action.payload)),
      };
      case DELETE_STOCKS:
        const { id, type } = action.payload;
        let filteredStocks;
        switch (type) {
          case "invoiceId":
            filteredStocks = state.stocks.filter(
              (stock) => !(idsMatch(stock.references?.invoiceId, id) && stock.transactionType === "SALES")
            );
            break;
          case "purchaseId":
            filteredStocks = state.stocks.filter(
              (stock) => !(idsMatch(stock.references?.purchaseId, id) && stock.transactionType === "PURCHASE")
            );
            break;
            case "stockAdjustmentId":
            filteredStocks = state.stocks.filter(
              (stock) => !(idsMatch(stock.references?.stockAdjustmentId, id) && stock.transactionType === "STOCK_ADJUSTMENT")
            );
            break;
          default:
            filteredStocks = state.stocks; // No filtering for unknown types like stockAdjustmentId
        }
        return { ...state, stocks: filteredStocks };
    default:
      return state;
  }
};

export default stocks;
